module.exports = __webpack_public_path__ + "media/images/favicon/favicon-96-377f1692bdb69dc74717a263400fa5d6.png";